var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0"},[_c('v-img',{attrs:{"src":require("@/assets/images/entrypages/10_FCT NOVA_DCV.jpg"),"height":"480","position":"center center"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }